/**
 * Outlet Context Plugin for Admin Contextual Panel
 *
 * Handles media outlet pages: /media_outlets/:slug
 */

import React from "react";
import { registerContext } from "../contextRegistry";
import MergeButton from "../MergeButton";

function OutletContextPanel({ contextProps }) {
  const { slug } = contextProps;
  return (
    <div>
      <p className="small text-muted mb-2">Viewing outlet: {slug}</p>
      <div className="d-grid gap-2">
        <MergeButton />
      </div>
    </div>
  );
}

// Register this context
registerContext({
  name: "outlet",
  priority: 10,
  patterns: [
    {
      // The real V2 route is /media_outlets/:slug (Frontend::MediaOutletsController) --
      // NOT /outlets/:slug, which matches no route in this app.
      pattern: /\/media_outlets\/([^/?]+)/,
      extract: (match) => ({ slug: match[1] }),
    },
  ],
  component: OutletContextPanel,
});

export default OutletContextPanel;
